
export enum NEGATIVATION_STATUS {
  PENDING = "PENDING",
  AWAITING_APPROVAL = "AWAITING_APPROVAL",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  CANCELLED = "CANCELLED",
  PROCESSED = "PROCESSED",
  UNDEFINED = "UNDEFINED",
  DUNNING_REQUESTED = "DUNNING_REQUESTED"
}

type reasonCancellation = {
  reason: string
  createdAt: Date
  author: string
}

export const emptyRentersNegative = () => ({
  _id: "",
  negativationId: "",
  companyId: "",
  dunningNumber: 0,
  status: NEGATIVATION_STATUS.UNDEFINED,
  type: "CREDIT_BUREAU",
  requestDate: new Date(),
  description: "",
  value: 0,
  feeValue: 0,
  netValue: 0,
  receivedInCashFeeValue: 0,
  denialReason: "",
  cancellationFeeValue: 0,
  isNecessaryResendDocumentation: false,
  canBeCancelled: false,
  cannotBeCancelledReason: "",
  externalReference: "",
  paymentId: "",
  createdAt: new Date(),
  updatedAt: new Date(),
  renterId: "",
  renterName: "",
  idPaymentsDeleted: [],
  invoiceNumber: 0,
  negativationCancellationReason: {
    reason: "",
    createdAt: new Date(),
    author: "",
  },
})

export interface PaymentDeleted {
  externalPaymentId: string;
  description: string;
  value: number;
}

export interface IRentersNegativation {
  _id?: string;
  negativationId?: string;
  companyId: string;
  dunningNumber: number;
  status: NEGATIVATION_STATUS;
  type: string;
  requestDate: Date;
  description: string;
  value: number;
  feeValue: number;
  netValue: number;
  receivedInCashFeeValue: number;
  denialReason: string;
  cancellationFeeValue: number;
  isNecessaryResendDocumentation: boolean;
  canBeCancelled: boolean;
  cannotBeCancelledReason: string;
  externalReference: string;
  createdAt: Date;
  updatedAt: Date;
  renterId: string;
  renterName: string;
  idPaymentsDeleted?: PaymentDeleted[];
  invoiceNumber: number;
  negativationCancellationReason: reasonCancellation;
}